import { useCallback, useEffect, useState } from "react";
import { Check, Loader2, Mail, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

const TYPE = { sponsor: "Sponsorship", press: "Stampa", fan: "Fan", other: "Altro" };

export const Messages = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/messages");
      setItems(Array.isArray(data) ? data : []);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const markRead = async (m) => { await api.patch(`/messages/${m.id}`); load(); };
  const remove = async (m) => {
    if (!window.confirm("Eliminare questo messaggio?")) return;
    await api.delete(`/messages/${m.id}`);
    toast.success("Messaggio eliminato");
    load();
  };

  return (
    <section data-testid="admin-panel-messages">
      <h2 className="font-display text-4xl font-black uppercase">Messaggi</h2>
      <div className="mt-6 space-y-3">
        {loading && <p className="flex items-center gap-2 text-zinc-400"><Loader2 className="h-4 w-4 animate-spin" /> Caricamento…</p>}
        {!loading && items.length === 0 && <p className="border border-white/10 p-6 text-zinc-400" data-testid="admin-messages-empty">Nessun messaggio ricevuto.</p>}
        {items.map((m, i) => (
          <article key={m.id} data-testid={`admin-message-${i}`} className={`border p-5 ${m.read ? "border-white/10" : "border-volt/50 bg-volt/[0.03]"}`}>
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div className="flex flex-wrap items-center gap-3">
                <span className="label-mono bg-white/10 px-2 py-1 text-[11px] text-white">{TYPE[m.type] || m.type}</span>
                {!m.read && <span className="label-mono text-[11px] text-volt">Nuovo</span>}
                <span className="font-mono text-xs text-zinc-400">{new Date(m.created_at).toLocaleString("it-IT")}</span>
              </div>
              <div className="flex gap-2">
                <a href={`mailto:${m.email}`} className="grid h-9 w-9 place-items-center border border-white/15 hover:border-volt hover:text-volt" aria-label="Rispondi" data-testid={`admin-message-reply-${i}`}><Mail className="h-4 w-4" /></a>
                {!m.read && <button onClick={() => markRead(m)} className="grid h-9 w-9 place-items-center border border-white/15 hover:border-volt hover:text-volt" aria-label="Segna come letto" data-testid={`admin-message-read-${i}`}><Check className="h-4 w-4" /></button>}
                <button onClick={() => remove(m)} className="grid h-9 w-9 place-items-center border border-white/15 hover:border-flag hover:text-flag" aria-label="Elimina" data-testid={`admin-message-delete-${i}`}><Trash2 className="h-4 w-4" /></button>
              </div>
            </div>
            <p className="mt-3 font-semibold text-white">{m.name} <span className="font-mono text-xs font-normal text-zinc-400">· {m.email}{m.company ? ` · ${m.company}` : ""}</span></p>
            <p className="mt-2 whitespace-pre-line text-sm leading-relaxed text-zinc-300">{m.message}</p>
          </article>
        ))}
      </div>
    </section>
  );
};
